import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { OrdersEdge } from '@shared/generated'
import { formatOrderReceiptType } from '@shared/uttils/order'

import styles from './styles.module.scss'

export default function ReceiptsModal ({
  data,
}: {
  data: NonNullable<NonNullable<OrdersEdge['edges']>[number]>;
}) {
  const { t: to } = useTranslation('order')
  const receipts = data.receipts ?? []

  return (
    <div className={styles.root}>
      {receipts.map((receipt) => {
        const { label, color } = formatOrderReceiptType(
          receipt?.type as string,
          to,
        )

        return (
          <a
            key={receipt?.id}
            href={receipt?.receiptPreviewUrl as string}
            target="_blank"
            rel="noopener noreferrer"
            className={classNames(styles.receipt, styles[`receipt--${color}`])}
          >
            {label}
          </a>
        )
      })}
    </div>
  )
}
